import { CnDepartmentSelect } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'DepartmentSelect',
    component: CnDepartmentSelect,
    formComponent: CnDepartmentSelect,
};
